import React from 'react';
import { usePanel } from 'contexts/panelContext';
import { useAuth } from 'contexts/authContext';
import MenteeProgressSteps from './MenteeProgressSteps';
import MentorProgressSteps from './MentorProgressSteps';

const DashboardProgressSteps = () => {
	const { panelType, userPairs } = usePanel();
	const { currentUser } = useAuth();
	const isProfessionalViewEnabled = Boolean(currentUser?.isProfessionalViewEnabled);

	if (!['mentor', 'mentee'].includes(panelType)) {
		return null;
	}

	if (panelType === 'mentor') {
		const showMenteeProgress = isProfessionalViewEnabled && (userPairs || []).length === 1;

		return (
			<div className="flex flex-column gap-3">
				<MenteeProgressSteps showProgress={showMenteeProgress} />
				{isProfessionalViewEnabled ? <MentorProgressSteps /> : null}
			</div>
		);
	}

	return <MenteeProgressSteps showProgress={isProfessionalViewEnabled} />;
};

export default DashboardProgressSteps;
